import React from 'react';
import { capitalize } from "../../../../../../Utils";
import { PARAMS_NAME } from "../../../../config";

const Head = ({ onSortChange, params }) => {
    let th = params.map(param => <th onClick={() => onSortChange(param)} key={param}>{PARAMS_NAME[param] || capitalize(param)}</th>);

    return (
        <thead>
            <tr>{th}</tr>
        </thead>
    )
};

export default Head;



// WEBPACK FOOTER //
// ./src/scenes/BidderCtrHourly/components/Table/components/Head/index.js